import { useCallback, useState } from 'react'

export type ModalProps = {
  show: boolean
  onHide: () => void
  onShow: () => void
  toggleVisibility: () => void
}

const useModal = (): ModalProps => {
  const [show, setShow] = useState<boolean>(false)

  const onShow = useCallback(() => {
    setShow(true)
  }, [])

  const onHide = useCallback(() => {
    setShow(false)
  }, [])

  const toggleVisibility = useCallback(() => {
    setShow((prev) => !prev)
  }, [])

  return {
    show,
    onHide,
    onShow,
    toggleVisibility,
  }
}

export default useModal
